const TABLE_PLACEHOLDER_STYLE = {
	border: '1px dashed #999',
	padding: '12px',
	margin: '12px 0 20px',
	backgroundColor: '#fafafa',
	fontWeight: 600,
}

const Term = () => {
	return (
		<div
			className="privacy-policy"
			style={{
				maxWidth: '980px',
				margin: '200px auto 0 auto',
				padding: '24px 16px 64px',
				lineHeight: 1.7,
			}}
		>
			<h1>[개인정보 처리지침]</h1>

			<p>
				대표전화 02-373-0075
				<br />
				개인정보 책임자 최환
				<br />
				적용일 2024. 01. 01
			</p>

			<p>
				DMC하나이비인후과 (이하 &quot;병원&quot;이라 함)는 개인정보 보호법 제30조에
				따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게
				처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리지침을
				수립·공개합니다.
			</p>

			<section>
				<h2>제1조(개인정보의 처리목적, 수집 항목, 보유 및 이용기간)</h2>
				<p>
					병원은 「개인정보 보호법」에 따라 서비스 제공을 위해 필요 최소한의 범위에서
					개인정보를 수집·이용합니다.
				</p>

				<h3>① 정보주체의 동의를 받지 않고 처리하는 개인정보 항목</h3>
				<p>
					병원은 개인정보 보호법 제15조제1항제2호(법률에 특별한 규정) 및 개인정보
					보호법 제15조제1항제4호(계약의 이행)의 목적으로 다음의 개인정보 항목을
					정보주체의 동의 없이 처리하고 있습니다.
				</p>
				<div style={{ overflowX: 'auto', margin: '12px 0 20px' }}>
					<table
						style={{
							width: '100%',
							borderCollapse: 'collapse',
							minWidth: '860px',
							fontSize: '14px',
						}}
					>
						<caption
							style={{ textAlign: 'left', fontWeight: 700, marginBottom: '8px' }}
						>
							표1. 정보주체 동의 없이 처리하는 개인정보 항목
						</caption>
						<thead>
							<tr>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									법적근거
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									구분
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									수집 목적
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									수집 항목
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									보유·이용기간
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									의료법 제22조(진료기록부 등)
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									진료서비스 제공 및 환자정보 관리
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									환자 진료 및 의료법에 따른 환자정보의 보존
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									주소, 이름, 주민등록번호, 전화번호
								</td>
								<td
									rowSpan={2}
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									의료법 시행규칙 제15조(진료기록부 등의 보존)의 별지7호서식에 따름
								</td>
							</tr>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									의료법 제22조(진료기록부 등)
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									진료기록부 관리
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									의료법에 따른 진료기록의 작성 및 보존
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									주소, 이름, 연락처, 주민등록번호, 병력 및 가족력, 주된 증상, 진단 결과
									또는 진단명, 진료 경과, 치료 내용, 진료일시
								</td>
							</tr>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									개인정보 보호법 제15조 제1항 제4호(계약의 이행)
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									원무 서비스
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									진료비 수납 등 원무 서비스 제공
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									카드 결제 승인 정보(이름, 카드사명, 카드종류, 카드번호, 유효기간)
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									전자상거래법 제6조, 국민건강보험요양급여의 기준에 관한 규칙
									제7조(요양급여비용 계산서·영수증의 발급 및 보존)에 따라 5년
								</td>
							</tr>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									약사법 제29조(처방전의 보존)
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									의약품 조제 및 처방전 관리
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									처방전 보존
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									이름, 주민등록번호, 의료기관 명칭과 전화번호 및 의료과목, 질병분류기호,
									의료인의 이름 및 면허종별·면허번호, 처방의약품, 발급연월일, 사용기간
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									약사법 제29조(처방전의 보존)에 따라 2년, 보험급여 처방전은
									국민건강보험법 제96조의2에 따라 3년간 보관
								</td>
							</tr>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									약사법 제30조(조제기록부)
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									조제 기록부 관리
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									조제기록부 관리 및 오남용 연구
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									가입자 이름, 건강보험증 번호, 환자이름, 주민등록번호, 질병명,
									요양급여·비용외 내용, 본인부담금 및 비율징수액, 처방전 내용
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									약사법 제30조(조제기록부)에 따라 5년, 요양급여 관련 서류는
									국민건강보험법 제96조의2 및 동법 시행규칙 제53조에 따라 5년간 보관
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<h3>② 정보주체의 동의를 받아 처리하는 개인정보 항목</h3>
				<p>
					병원은 다음의 개인정보 항목을 정보주체의 동의를 받아 처리하고 있습니다.
				</p>
				<div style={{ overflowX: 'auto', margin: '12px 0 20px' }}>
					<table
						style={{
							width: '100%',
							borderCollapse: 'collapse',
							minWidth: '860px',
							fontSize: '14px',
						}}
					>
						<caption
							style={{ textAlign: 'left', fontWeight: 700, marginBottom: '8px' }}
						>
							표2. 정보주체 동의를 받아 처리하는 개인정보 항목
						</caption>
						<thead>
							<tr>
								<th
									colSpan={2}
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									구분
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									수집항목
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									보유·이용기간
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td
									rowSpan={2}
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									홈페이지 서비스
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									필수항목
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									[만 14세 이상]
									<br />
									로그인 ID, 비밀번호, 이름, 휴대폰 번호, 이메일, 주소, 암호화된 동일인
									식별정보(CI, DI)
									<br />
									<br />
									[만 14세 미만]
									<br />
									로그인 ID, 비밀번호, 만 14세 미만 회원의 이름, 생년월일, 휴대폰번호,
									이메일, 주소, 암호화된 동일인 식별정보(CI, DI), 법정대리인의 이름,
									휴대폰번호, 이메일
									<br />
									※ SNS 회원가입
									<br />
									네이버: 네이버ID, 이름, 이메일 주소, 휴대폰 번호
									<br />
									카카오: 카카오ID, 이름
								</td>
								<td
									rowSpan={2}
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									회원탈퇴 또는 회원자격 상실시까지
								</td>
							</tr>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									필수항목
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									전화번호
								</td>
							</tr>

							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									홈페이지 간편회원
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									필수항목
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									전화번호
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									1개월
								</td>
							</tr>

							<tr>
								<td
									rowSpan={3}
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									모바일 환자용 앱
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									필수항목
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									암호화된 동일인 식별정보(CI) 또는 아이핀 제공정보, 이름, 로그인 ID,
									비밀번호, 휴대폰 번호, 주민등록번호 (환자번호, 휴대폰번호, 사용)
									<br />
									※ SNS 회원가입
									<br />
									네이버: 이름, 이메일
									<br />
									카카오: 이름, 휴대폰번호
									<br />
									페이스북: 이름, 휴대폰번호
								</td>
								<td
									rowSpan={3}
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									회원탈퇴 또는 회원자격 상실시까지
								</td>
							</tr>
							<tr>
								<td
									rowSpan={2}
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									선택항목
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									일반 회원가입: 이메일
								</td>
							</tr>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									영리인 회원가입: 법정대리인의 본인 인증정보(이름, 휴대폰 번호)
								</td>
							</tr>

							<tr>
								<td
									rowSpan={2}
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									진료협력 홈페이지
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									필수항목
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									회원ID, 진료과, 비밀번호, 의사면허번호, 성명, 이메일, 휴대폰 번호,
									출신학교, 전문분야
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									회원 탈퇴시 까지
								</td>
							</tr>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									선택항목
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									회원의사명, 전문의번호, 등록여부, 수련병원
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									동의 철회시 까지
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<ul>
					<li>
						이외 환자의 치료에 필요한 경우, 호흡기 환자의 환경(유해물질흡입가능성,
						화학물질흡입가능성), 후두(성대)상태의 이상, 음성과용자의 음성치료,
						수면치료를 위한 수면검사 시 교대업무 또는 수면시간이 특별한 경우 이에 따른
						업무(직업)정보를 수집합니다.
					</li>
					<li>
						유행성 호흡기 또는 해외여행에서 걸릴수 있는 질환의 경우 여행력을
						수집합니다.
					</li>
				</ul>
			</section>

			<section>
				<h2>제2조(만 14세 미만 아동의 개인정보 처리에 관한 사항)</h2>
				<ol>
					<li>
						병원은 14세 미만 아동의 개인정보를 처리하기 위하여 동의가 필요한 경우에는
						해당 아동의 법정대리인으로부터 동의를 받습니다.
					</li>
					<li>
						병원은 14세 미만 아동의 개인정보 처리에 관하여 그 법정대리인의 동의를 받을
						때에는 아동에게 법정대리인의 성명, 연락처와 같이 최소한의 정보를 요구할 수
						있으며, 동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를
						표시하도록 하고, 그 동의 표시를 확인하였음을 법정대리인의 휴대전화
						문자메시지로 알리는 방법으로 그 사실을 확인합니다.
					</li>
					<li>
						아동의 법정대리인은 아동의 개인정보에 대한 열람, 정정 및 삭제를 요청할 수
						있습니다. 아동의 개인정보를 열람·정정, 삭제하고자 할 경우에는
						회원정보수정을 클릭하여 아동의 개인정보를 열람·정정, 삭제하실 수 있습니다.
					</li>
				</ol>
			</section>

			<section>
				<h2>제3조(개인정보의 제3자 제공)</h2>
				<ol>
					<li>
						병원은 정보주체의 개인정보를 명시한 범위 내에서만 처리하며, 정보주체의
						동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에
						해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 정보주체의
						개인정보를 제3자에게 제공하지 않습니다.
					</li>
					<li>
						병원은 다음과 같이 개인정보를 제3자에게 제공하고 있습니다. 제공받는 자의
						보유·이용기간은 관련 법률에 근거한 기간까지 보유·이용합니다.
					</li>
				</ol>
				<div style={{ overflowX: 'auto', margin: '12px 0 20px' }}>
					<table
						style={{
							width: '100%',
							borderCollapse: 'collapse',
							minWidth: '860px',
							fontSize: '14px',
						}}
					>
						<caption
							style={{ textAlign: 'left', fontWeight: 700, marginBottom: '8px' }}
						>
							표3. 개인정보의 제3자 제공 내역
						</caption>
						<thead>
							<tr>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									개인정보를 제공받는 자
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									제공받는 자의 개인정보 이용목적
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									제공근거
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									제공하는 개인정보
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									국민건강보험공단, 건강보험심사평가원
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									급여비용 심사, 지급·대상여부 확인
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									국민건강보험법 제13조, 제43조, 제56조, 의료급여법 제5조, 제11조, 제33조
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									[진료기록 정보] 이름, 주민등록번호, 진단명, 진료내역
								</td>
							</tr>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									근로복지공단
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									급여비용 심사·지급·대상여부 확인
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									산업재해보상보험법 제31조
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									[진료기록 정보] 이름, 주민등록번호, 진단명, 진료내역
								</td>
							</tr>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									중앙암등록본부
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									국가 암환자 통계 산출
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									암관리법 제14조
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									[암등록 신고내역] 이름, 주민등록번호, 나이, 직업, 혼인여부, 진단경로,
									원발부위, 재발/이중암, 조직학적진단, 분화도, 사망년월일, 사망원인,
									진단방법, 치료병원, SEER병기, TNM, Stage병기, 전이부위
								</td>
							</tr>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									질병관리본부
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									법정 감염병 보고
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									감염병 예방 및 관리에 관한 법률 제11조
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									[진료기록 정보] 이름, 주민등록번호, 성별, 진단명, 진료내역
								</td>
							</tr>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									국세청
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									연말정산용 증빙근거 신고
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									소득세법 제160조의3
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									[후원인 정보] 이름, 주민등록번호, 진료주소, 진단명, 휴대폰 번호
								</td>
							</tr>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									회송서 수신기관(의료기관 및 보건복지부, 건강보험심사평가원)
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									보건복지부 진료의뢰·회송 사업 수행
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									보건복지부 고시 제2020-221호, 제242호, 제2022-265호
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									이름, 연락처, 주민등록번호, 주소, 환자상태 및 진료소견, 의뢰(회송)
									사유, 각종 진료정보
								</td>
							</tr>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									진료정보 교류기관(의료기관 및 보건복지부)
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									보건복지부 진료정보교류사업 수행
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									보건복지부 고시 제2016-233호, 제2021-11호, 진료정보교류사업지침,
									정보주체의 동의
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									이름, 연락처, 주민등록번호, 주소, 환자상태 및 의뢰(회송) 사유, 각종
									진료정보
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>

			<section>
				<h2>제4조(개인정보처리의 위탁)</h2>
				<ol>
					<li>
						병원은 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를
						위탁하고 있습니다.
					</li>
				</ol>
				<div style={{ overflowX: 'auto', margin: '12px 0 20px' }}>
					<table
						style={{
							width: '100%',
							borderCollapse: 'collapse',
							minWidth: '720px',
							fontSize: '14px',
						}}
					>
						<caption
							style={{ textAlign: 'left', fontWeight: 700, marginBottom: '8px' }}
						>
							표4. 개인정보 처리업무 위탁 내역
						</caption>
						<thead>
							<tr>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									수탁사
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									수탁 업무의 내용
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									써킷
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									수탁검사(혈액 및 기타 검사, 병리검사)
								</td>
							</tr>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									(주)한국신용카드결제
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										verticalAlign: 'top',
									}}
								>
									신용카드 결제 등 업무
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<ol start={2}>
					<li>
						병원은 위탁계약 체결시 개인정보 보호법 제26조에 따라 위탁업무 수행 목적 외
						개인정보처리 금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한
						관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고,
						수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
					</li>
				</ol>
			</section>

			<section>
				<h2>제5조(개인정보의 추가적인 이용·제공 판단 기준)</h2>
				<p>
					개인정보의 추가적 이용·제공이 지속적으로 발생하는 경우, 아래와 같은 사항을
					고려한 판단기준을 개인정보 처리방침에 공개하도록 하겠습니다.
				</p>
				<ol>
					<li>당초 수집 목적과 관련성이 있는지 여부</li>
					<li>
						개인정보를 수집한 정황 또는 처리 관행에 비추어 볼 때 개인정보의 추가적인
						이용 또는 제공에 대한 예측 가능성이 있는지 여부
					</li>
					<li>정보주체의 이익을 부당하게 침해하는지 여부</li>
					<li>가명처리 또는 암호화 등 안전성 확보에 필요한 조치를 하였는지 여부</li>
				</ol>
			</section>

			<section>
				<h2>제6조(개인정보의 파기)</h2>
				<ol>
					<li>
						병원은 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게
						되었을 때에는 지체없이 해당 개인정보를 파기합니다.
					</li>
					<li>
						정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이
						달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는
						경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를
						달리하여 보존합니다.
					</li>
					<li>
						병원은(는) 폐업 또는 휴업 신고를 할 때에는 기록·보존하고 있는 진료기록부,
						조산기록부, 간호기록, 그 밖의 진료에 관한 기록을 관할 보건소장에게
						이관합니다.
					</li>
					<li>
						개인정보 파기의 절차 및 방법은 다음과 같습니다.
						<br />
						파기절차: 병원은 파기 사유가 발생한 개인정보를 선정하고, 병원의 개인정보
						보호책임자의 승인을 받아 개인정보를 파기합니다.
						<br />
						파기방법: 병원은 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할
						수 없도록 디가우저를 이용하여 파기하며, 종이 문서에 기록·저장된 개인정보는
						분쇄기로 분쇄하거나 소각하여 파기합니다.
					</li>
				</ol>
			</section>

			<section>
				<h2>제7조(정보주체와 법정대리인의 권리/의무 및 그 행사방법에 관한 사항)</h2>
				<ol>
					<li>
						정보주체는 병원에 대해 언제든지 다음 각 호의 권리를 행사할 수 있습니다.
						<ul>
							<li>환자(본인)에 관한 기록 열람, 정정, 삭제, 처리정지 요구</li>
							<li>그 외 개인정보 열람·정정·삭제·처리정지 요구</li>
						</ul>
						※ 만 14세 미만 아동에 관한 개인정보의 열람등 요구는 법정대리인이 직접 해야
						하며, 만 14세 이상의 미성년자인 정보주체는 정보주체의 개인정보에 관하여
						미성년자 본인이 권리를 행사하거나 법정대리인을 통하여 권리를 행사할 수도
						있습니다.
					</li>
				</ol>

				<p>제1항 각 호의 권리 행사는 다음의 방법으로 하실 수 있습니다.</p>
				<ul>
					<li>
						환자(본인)에 관한 기록 열람, 정정, 삭제, 처리정지 요구: 본인임을 확인할 수
						있는 신분증(주민등록증, 여권, 운전면허증 등)을 병원에 제시
					</li>
					<li>
						그 외 개인정보 열람, 정정, 삭제, 처리정지 요구: 「개인정보 보호법」 시행령
						제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX)
					</li>
				</ul>

				<p>
					제1항 각 호에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등
					대리인을 통하여 하실 수도 있습니다.
				</p>
				<ul>
					<li>
						환자(본인)에 관한 기록 열람, 정정, 삭제, 처리정지 요구:
						<ul>
							<li>기록열람이나 사본발급을 요청하는 자의 신분증 사본</li>
							<li>
								환자가 자필 서명한 「의료법 시행규칙」 별지 제9호의2서식의 동의서 및
								별지 제9호의3서식의 위임장 (환자가 만 14세 미만인 경우에는 법정대리인
								작성 및 법정대리인 확인 서류 첨부)
							</li>
							<li>
								환자의 신분증 사본(다만, 환자가 만 17세 미만으로 「주민등록법」
								제24조제1항에 따른 주민등록증이 발급되지 아니한 자는 제외)
							</li>
						</ul>
					</li>
					<li>
						그 외 개인정보 열람, 정정, 삭제, 처리정지 요구: "개인정보 처리 방법에 관한
						고시(제2023-12호)" 별지 제11호 서식에 따른 위임장을 제출
					</li>
				</ul>

				<p>제1항 각 호에 따른 권리 행사는 다음의 경우에는 제한될 수 있습니다.</p>
				<ul>
					<li>
						환자(본인)에 관한 기록 열람, 정정, 삭제, 처리정지 요구: 국가안보에 긴요한
						사안으로 "다른 법률에 따라 진행 중인 감사 및 조사에 관한 업무"를
						수행하는데 지장을 초래할 때
					</li>
					<li>
						그 외 개인정보 열람, 정정, 삭제, 처리정지 요구: 「개인정보 보호법」 제35조
						제4항 각 호, 제37조 제2항 각 호에 해당되는 경우
					</li>
				</ul>

				<p>
					병원은 제1항 각 호의 권리행사를 한 자가 본인이거나 정당한 대리인인지를
					확인합니다.
				</p>
			</section>

			<section>
				<h2>제8조(개인정보의 안전성 확보조치)</h2>
				<p>
					병원은 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
				</p>
				<ol>
					<li>관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육 등</li>
					<li>
						기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치,
						고유식별정보 등의 암호화, 보안프로그램 설치
					</li>
					<li>물리적 조치: 정보기술팀, 의료정보관리팀 등의 접근통제</li>
				</ol>
			</section>

			<section>
				<h2>제9조(개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항)</h2>
				<ol>
					<li>
						병원은 제공하는 인터넷 서비스를 통하여 이용정보를 저장하고 불러오는
						쿠키(cookie)를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가
						이용자의 브라우저에게 보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의
						하드디스크에 저장됩니다.
					</li>
				</ol>
				<ul>
					<li>
						쿠키의 사용 목적: 정보주체(회원/비회원, 이용자)들이 방문한 병원의 각
						서비스와 웹 사이트들에 대한 방문 및 이용형태, 보안접속 여부
					</li>
					<li>
						쿠키의 설치/운영 및 거부: 정보주체(회원/비회원, 이용자)는 쿠키 설치에 대한
						선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서 옵션을
						설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나,
						아니면 모든 쿠키의 저장을 거부할 수도 있습니다. 다만, 쿠키의 저장을 거부할
						경우 일부서비스는 이용에 어려움이 있을 수 있습니다.
					</li>
					<li>
						거부방법:
						<ul>
							<li>
								Internet Explorer 11: 웹 브라우저 상단의 도구 메뉴 &gt; 인터넷옵션 &gt;
								개인정보 &gt; 고급
							</li>
							<li>
								Microsoft Edge: 웹 브라우저 상단의 설정 및 기타 메뉴 &gt; 쿠키 및 사이트
								권한 &gt; 쿠키 및 사이트 데이터 관리 및 삭제 &gt; "사이트에서 쿠키
								데이터를 저장하고 읽도록 허용" 비활성화
							</li>
							<li>
								Chrome: 웹 브라우저 우측의 설정 메뉴 &gt; 개인 정보 및 보안 &gt; 쿠키 및
								기타 사이트 데이터
							</li>
						</ul>
					</li>
				</ul>
			</section>

			<section>
				<h2>제10조(가명정보의 처리)</h2>
				<ol>
					<li>
						가명정보의 처리 목적: 병원은 개인정보 보호법 제28조의2에 따라 통계작성,
						과학적 연구, 공익적 기록보존 등을 위하여 가명정보를 처리하고 있습니다.
					</li>
					<li>
						가명정보의 처리 및 보유기간: 가명정보는 수집·이용 목적으로 명시한 범위
						내에서 처리하며, 개인정보 보호법 및 관련법령에서 정하는 보유기간을
						준용하여 이행하고 있습니다.
					</li>
					<li>
						가명정보의 제3자 제공에 관한 사항: 개인정보보호법 제28조의4제2항에 따라
						가명정보를 제3자에 제공하는 경우 다음 각 호의 사항을 포함하고 있습니다.
						<ul>
							<li>가명정보를 제공받는 자</li>
							<li>가명정보를 제공받는 자의 보유 및 이용기간</li>
							<li>가명정보를 제공받는 자의 이용목적</li>
							<li>제공하는 가명정보의 항목</li>
							<li>가명정보의 이용방법</li>
							<li>가명정보의 재식별 위험 관리</li>
						</ul>
					</li>
					<li>
						가명정보처리의 위탁에 관한 사항: 가명정보 처리업무를 외부에 위탁계약
						체결시 다음 각호의 내용이 포함된 내용을 문서에 명시하고 있습니다.
						<ul>
							<li>가명정보의 재식별 금지에 관한 사항</li>
							<li>가명정보의 재제공 또는 재위탁 제한에 관한 사항</li>
							<li>가명정보의 재식별 위험 발생시 통지에 관한 사항</li>
						</ul>
					</li>
					<li>
						처리하는 가명정보 항목: 최소처리 원칙을 준수하여 가명정보 처리 업무 목적에
						필요한 최소한의 항목만을 가명처리 대상으로 선정하여 처리하고 있습니다.
					</li>
					<li>
						가명정보의 파기: 가명정보의 재식별 위험 발생 시 가명처리를 즉시 중단하고
						지체 없이 파기합니다.
					</li>
					<li>
						가명정보의 안전성 확보조치에 관한 사항: 개인정보 보호법 제28조의4에 따라
						다음과 같이 가명정보의 안전성 확보를 위하여 관리적, 기술적, 물리적
						대책으로 여러 보안장치를 마련하고 있습니다.
						<ul>
							<li>관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육</li>
							<li>
								기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치,
								고유식별정보 등의 암호화, 보안프로그램 설치
							</li>
							<li>물리적 조치: 전산실, 자료보관실 등의 접근통제</li>
						</ul>
					</li>
				</ol>
			</section>

			<section>
				<h2>
					제11조(개인정보 보호책임자의 성명 또는 개인정보 업무 담당부서 및 고충사항을
					처리하는 부서에 관한 사항)
				</h2>
				<ol>
					<li>
						병원은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와
						관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보
						보호책임자를 지정하고 있습니다.
					</li>
				</ol>
				<ul>
					<li>
						개인정보 보호책임자: 성명 최환 / 직책 대표원장 / 연락처 02-373-0075
					</li>
					<li>개인정보보호 담당부서: 원무팀 / 연락처 02-373-0075</li>
				</ul>
				<ol start={2}>
					<li>
						정보주체는 병원의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보
						보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및
						담당부서로 문의하실 수 있습니다. 병원은 정보주체의 문의에 대해 지체없이
						답변 및 처리해드릴 것입니다.
					</li>
				</ol>
			</section>

			<section>
				<h2>제12조(정보주체의 권익침해에 대한 구제방법)</h2>
				<p>
					정보주체는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을
					문의할 수 있습니다.
				</p>
				<p>
					아래의 기관은 병원과는 별개의 기관으로서, 병원의 자체적인 개인정보
					불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면
					문의하여 주시기 바랍니다.
				</p>
				<ul>
					<li>
						개인정보 침해신고센터(한국인터넷진흥원 운영): privacy.kisa.or.kr / (국번
						없이) 118 / (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층
						개인정보침해신고센터
					</li>
					<li>
						개인정보 분쟁조정위원회: www.kopico.go.kr / (국번 없이) 1833-6972 /
						(03171) 서울특별시 종로구 세종대로 209 정부서울청사 12층
					</li>
					<li>대검찰청: www.spo.go.kr / (국번 없이) 1301</li>
					<li>경찰청: ecrm.police.go.kr / (국번 없이) 182</li>
				</ul>
			</section>

			<section>
				<h2>제13조(고정형 영상정보처리기기 운영·관리에 관한 사항)</h2>
				<ol>
					<li>
						병원은 아래와 같이 영상정보처리기기를 설치·운영하고 있습니다.
						<ul>
							<li>
								영상정보처리기기의 설치 근거 및 설치 목적: 개인정보보호법 제25조 제1항에
								따라 시설안전 및 관리, 화재 예방, 범죄예방 안전관리, 범죄의 예방 및
								수사, 외부인 출입감시
							</li>
						</ul>
					</li>
				</ol>
				<div style={{ overflowX: 'auto', margin: '12px 0 20px' }}>
					<table
						style={{
							width: '100%',
							borderCollapse: 'collapse',
							minWidth: '760px',
							fontSize: '14px',
						}}
					>
						<caption
							style={{ textAlign: 'left', fontWeight: 700, marginBottom: '8px' }}
						>
							표5. 영상정보처리기기 설치대수, 설치위치 및 촬영범위
						</caption>
						<thead>
							<tr>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									위치
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									설치대수
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									DVR 보관장소
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									기타
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>대기실</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										textAlign: 'center',
									}}
								>
									2
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>
									DVR 보관실
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}></td>
							</tr>
							<tr>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>진료실</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										textAlign: 'center',
									}}
								>
									3
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>
									DVR 보관실
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}></td>
							</tr>
							<tr>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>수술실</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										textAlign: 'center',
									}}
								>
									1
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>
									DVR 보관실
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}></td>
							</tr>
							<tr>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>
									진료실 앞 복도
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										textAlign: 'center',
									}}
								>
									1
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>
									DVR 보관실
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}></td>
							</tr>
							<tr>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>병원 입구</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										textAlign: 'center',
									}}
								>
									1
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>
									DVR 보관실
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}></td>
							</tr>
							<tr>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>
									입원실 복도
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										textAlign: 'center',
									}}
								>
									1
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>
									DVR 보관실
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}></td>
							</tr>
							<tr>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>조정실</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										textAlign: 'center',
									}}
								>
									1
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>
									DVR 보관실
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}></td>
							</tr>
							<tr>
								<td
									style={{ border: '1px solid #ccc', padding: '10px', fontWeight: 700 }}
								>
									합계
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										textAlign: 'center',
										fontWeight: 700,
									}}
								>
									10
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}></td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}></td>
							</tr>
						</tbody>
					</table>
				</div>
				<div style={{ overflowX: 'auto', margin: '12px 0 20px' }}>
					<table
						style={{
							width: '100%',
							borderCollapse: 'collapse',
							minWidth: '760px',
							fontSize: '14px',
						}}
					>
						<caption
							style={{ textAlign: 'left', fontWeight: 700, marginBottom: '8px' }}
						>
							표6. 관리책임자 및 접근권한자
						</caption>
						<thead>
							<tr>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									구분
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									직위
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									DVR
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									연락처
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>
									관리책임자
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>대표원장</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>대표원장</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>
									02-373-0075
								</td>
							</tr>
							<tr>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>
									출결업무담당자
								</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>대표원장</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>대표원장</td>
								<td style={{ border: '1px solid #ccc', padding: '10px' }}>
									02-373-0075
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div style={{ overflowX: 'auto', margin: '12px 0 20px' }}>
					<table
						style={{
							width: '100%',
							borderCollapse: 'collapse',
							minWidth: '640px',
							fontSize: '14px',
						}}
					>
						<caption
							style={{ textAlign: 'left', fontWeight: 700, marginBottom: '8px' }}
						>
							표7. 영상정보 촬영시간, 보관기간, 보관장소
						</caption>
						<thead>
							<tr>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									촬영시간
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									보관기간
								</th>
								<th
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										background: '#f3f4f6',
									}}
								>
									보관장소
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										textAlign: 'center',
									}}
								>
									24시간
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										textAlign: 'center',
									}}
								>
									촬영일로부터 14 ~ 30일
								</td>
								<td
									style={{
										border: '1px solid #ccc',
										padding: '10px',
										textAlign: 'center',
									}}
								>
									DVR 보관실
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<ol start={3}>
					<li>
						위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보
						처리방침을 통하여 공개하도록 하겠습니다.
					</li>
					<li>
						개인정보 처리 업무의 재위탁은 원칙적으로 금지하고 있으나, 불가피한 사유로
						재위탁이 필요한 경우 반드시 병원의 사전 승인을 득하도록 안내하고 있으며,
						필요한 최소한의 범위로 한정하여 재위탁합니다.
					</li>
				</ol>

				<ul>
					<li>
						처리방법: 개인영상정보의 목적 외 이용, 제3자 제공, 파기, 열람 등 요구에
						관한 사항을 기록·관리하고, 보관기간 만료 시 복원이 불가능한 방법으로
						영구삭제(종이 출력물의 경우 파쇄)합니다.
					</li>
					<li>
						개인영상정보의 확인 방법 및 장소: 영상정보 관리책임자에게 미리 연락 후
						방문 확인 가능 / 확인 장소는 총무팀 또는 안내센터
					</li>
					<li>
						정보주체의 영상정보 열람 등 요구에 대한 조치:
						<ul>
							<li>
								붙임 개인영상정보 청구서를 제출하면 언제든지 영상정보처리기기 운영자에게
								요구할 수 있습니다.
							</li>
							<li>
								병원은 열람 또는 존재확인·삭제를 요구한 경우 지체 없이 필요한 조치를
								합니다.
							</li>
							<li>
								다만 다음 사유에 해당하는 경우 열람 등 청구를 거부할 수 있으며,
								거부사유는 10일 내 서면 통지합니다.
							</li>
						</ul>
					</li>
				</ul>

				<p>개인영상정보 열람 등의 청구를 거부할 수 있는 사유</p>
				<ul>
					<li>범죄수사·공소유지·재판수행에 중대한 지장을 초래하는 경우</li>
					<li>
						특정 정보주체의 영상정보만을 삭제하는 것이 기술적으로 현저히 곤란한 경우
					</li>
					<li>
						정보주체의 영상정보 열람 등 요구가 타인의 사생활권이 침해될 우려가 큰 경우
					</li>
					<li>
						기타 열람 등의 요청을 거절할 만한 정당한 공익적 사유가 존재하는 경우
					</li>
				</ul>

				<p>
					영상정보의 안전성 확보조치: 병원에서 처리하는 영상정보는 암호화 조치 등을
					통하여 안전하게 관리되고 있습니다. 또한 개인영상정보보호를 위한 관리적
					대책으로 개인정보에 대한 접근 권한을 차등 부여하고, 개인영상정보의 위·변조
					방지를 위하여 생성 일시, 열람 목적·열람자·열람 일시 등을 기록·관리하고
					있습니다. 이외에도 안전한 물리적 보관을 위하여 출입통제장치를 설치하여
					접근승인자 외의 출입을 통제하며 출입기록을 관리하고 있습니다.
				</p>
			</section>

			<section>
				<h2>제14조(개인정보 처리방침 변경)</h2>
				<p>이 개인정보 처리방침은 2024.01.1. 부터 적용합니다.</p>
			</section>
		</div>
	)
}

export default Term
